import React, { Fragment, useEffect, useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
  OptionTableCell,
  isArrayNotEmpty,
  isArrayEmpty,
  AlertSpg,
  SecurityRole,
  SecurityGuard,
  TableButton,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { Button, Table, TableContainer, TableHead } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import ServiceDefinitionViewDialog from "./dialog/ServiceDefinitionViewDialog";
import ServiceDefinitionEditDialog from "./dialog/ServiceDefinitionEditDialog";
import ServiceDefinitionCreateDialog from "./dialog/ServiceDefinitionCreateDialog";
import { openModal } from "../../../../../store/redux/slice/ComponentsControl/serviceDefinitionControl";
import ServiceDefinitionDeleteDialog from "./dialog/ServiceDefinitionDeleteDialog";

function compareByDescription(a, b) {
  if (a.description < b.description) {
    return -1;
  }
  if (a.description > b.description) {
    return 1;
  }
  return 0;
}

const ServiceDefinitionsListTable = ({ serviceDefinitions }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [sortedDefinitions, setSortedDefinitions] = useState([]);

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  useEffect(() => {
    setSortedDefinitions(
      serviceDefinitions
        .map((id) => {
          return { description: t(`m.${id}`), id: id };
        })
        .sort(compareByDescription),
    );
  }, [serviceDefinitions, t]);

  return (
    <>
      <Fragment>
        <ServiceDefinitionViewDialog></ServiceDefinitionViewDialog>
        <ServiceDefinitionEditDialog></ServiceDefinitionEditDialog>
        <ServiceDefinitionCreateDialog></ServiceDefinitionCreateDialog>
        <ServiceDefinitionDeleteDialog></ServiceDefinitionDeleteDialog>
        <TableContainer>
          <Table aria-label="table">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 35 }}>{t("l.table.head.number")}</TableCell>
                <TableCell>{t("l.table.head.service")}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            {isArrayNotEmpty(sortedDefinitions) && (
              <TableBody>
                {sortedDefinitions.map((definition, index) => {
                  return (
                    <TableRow hover key={definition.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{definition.description}</TableCell>
                      <OptionTableCell>
                        <TableButton
                          type={"view"}
                          onClick={() => {
                            handleOpenModal(definition.id, "view");
                          }}
                        />
                        <SecurityGuard checkForRoles={[SecurityRole.ServiceDefinitionEdit]}>
                          <TableButton
                            type={"edit"}
                            onClick={() => {
                              handleOpenModal(definition.id, "edit");
                            }}
                          />
                          <TableButton
                            type={"remove"}
                            onClick={() => {
                              handleOpenModal(definition.id, "delete");
                            }}
                          />
                        </SecurityGuard>
                      </OptionTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
          {isArrayEmpty(sortedDefinitions) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
        </TableContainer>

        <SecurityGuard checkForRoles={[SecurityRole.ServiceDefinitionEdit]}>
          <Button
            style={{ marginTop: "20px" }}
            startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
            size={"medium"}
            type={"button"}
            variant="contained"
            color="secondary"
            onClick={() => {
              handleOpenModal(null, "create");
            }}
          >
            {t("l.btn.create.serviceDefinition")}
          </Button>
        </SecurityGuard>
      </Fragment>
    </>
  );
};

export default ServiceDefinitionsListTable;
